import classNames from 'classnames';
import type { FC, KeyboardEventHandler, ReactNode } from 'react';
import { getAccessibleTabIndex } from '../Button/ariaHelpers';
import type { IconGlyph, IconStyle } from '../Icon/IconGlyph';
import { paddingMinusBorder } from '../utils/tailwind/paddingMinusBorder';

type IntentFilterButtonProps = {
  children?: ReactNode;
  disabled?: boolean;
  icon?: IconGlyph;
  iconStyle?: IconStyle;
  onClick?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLButtonElement>;
  open: boolean;
};

export const IntentFilterButton: FC<IntentFilterButtonProps> = (props) => (
  <button
    className={classNames(
      'block size-7',
      'border border-default rounded-sm subtract-border',
      'bg-white hover:bg-state-hover active:bg-state-press',
      paddingMinusBorder['2xs'],
      props.open && 'rounded-b-none',
    )}
    type='button'
    onClick={props.onClick}
    tabIndex={getAccessibleTabIndex(props.disabled)}
  >
    {props.children}
  </button>
);
